import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { SupplierFilters, SupplierFiltersQuery } from "../../productSuppliers/models/models";
import { CustomerBuyerStockItem, CustomerBuyerStockItemsQuery, FiltersGroupedStockItems, FiltersGroupedStockItemQuery, GroupedStockItem, GroupedStockItemQuery, StockItemSuppliersQuery, StockItemSupplier, StockItemSupplierDetails } from "../models/customerBuyerStockItemsModels"

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerBuyerStockItemsApi {
  getStockItems(query: CustomerBuyerStockItemsQuery): Promise<Page<CustomerBuyerStockItem>> {
    return api.get<Page<CustomerBuyerStockItem>>(`/v1/buyer/stock-items`, { ...getRequestConfig(), params: query }).then(x => x.data);
  }

  getStockItem(id: string): Promise<CustomerBuyerStockItem> {
    return api.get<CustomerBuyerStockItem>(`/v1/buyer/stock-items/${id}`, getRequestConfig()).then(x => x.data);
  }

  getFiltersGroupedStockItems(query: FiltersGroupedStockItemQuery): Promise<FiltersGroupedStockItems> {
    return api.get<FiltersGroupedStockItems>(`/v1/buyer/products/filters`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } }).then(x => x.data);
  }

  getGroupedStockItems(query: GroupedStockItemQuery): Promise<Page<GroupedStockItem>> {
    return api.get<Page<GroupedStockItem>>(`/v1/buyer/products`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } }).then(x => x.data);
  }

  getGroupedStockItem(productId: string): Promise<GroupedStockItem> {
    return api.get<GroupedStockItem>(`/v1/buyer/products/${productId}`, getRequestConfig()).then(x => x.data);
  }

  getStockItemSuppliers(productId: string, query: StockItemSuppliersQuery): Promise<Page<StockItemSupplier>> {
    return api.get<Page<StockItemSupplier>>(
      `/v1/buyer/products/${productId}/suppliers`,
      { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getStockItemSuppliersFilters(productId: string, query: SupplierFiltersQuery): Promise<SupplierFilters> {
    return api.get<SupplierFilters>(
      `/v1/buyer/products/${productId}/suppliers/filters`,
      { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getStockItemSupplierDetails(productId: string, supplierId: string): Promise<StockItemSupplierDetails> {
    return api.get<StockItemSupplierDetails>(
      `/v1/buyer/products/${productId}/suppliers/${supplierId}`, getRequestConfig())
      .then(x => x.data);
  }
}

export default new CustomerBuyerStockItemsApi();